import React from 'react'
import styled from 'styled-components'


interface TextProps {
    width?: number,
    height?: number,
    iconName?: string,
    align?: string,
    err?: boolean,
    disabled?: boolean,
    placeholderColor?: string,
    bgColor?: string
    textColor?: string,
}




const TextInp = styled.textarea<TextProps>`
   width: ${props=> props.width ? `${props.width}px` : '90%'};
   max-width: 560px;
   height: ${props=> props.height ? props.height : 144}px;
   padding: ${props=>props.iconName ? '10px 37px 10px 14px' : '10px'};
   background-color: ${props => props.bgColor ? props.bgColor : '#6C757D'};
   font-family: Cairo;
   color: ${props => props.textColor ? props.textColor : '#fff'};
   border: 0;
   font-size: 14px;
   outline: none;
   resize: none;
   text-align: ${props => props.align ? props.align : 'right'};
   border: 2px solid ${props=>props.err ? 'red' :  'rgba(0,0,0,0.2)'};
   transition: border 0.2s ease;
   direction: rtl;
   border-radius: 5px;
     &::placeholder{
         color: ${props => props.placeholderColor ? props.placeholderColor : '#BBBBBB'};
     }
     &:hover{
         border-color: ${props=> props.disabled ? 'red' : '#BBBBBB'}
     }
     &:focus{
     border-color: #BBBBBB;
     }
     &:active{
         border-color: #BBBBBB;
     }
`


interface Props {
    width?: number,
    height?: number,
    iconName?: string,
    align?: string,
    err?: boolean,
    disabled?: boolean,
    placeholderColor?: string,
    placeholder?: string,
    bgColor?: string
    textColor?: string,
    value?: string,
    handleChange?: React.ChangeEventHandler<HTMLTextAreaElement>,
    style?: React.CSSProperties
}

export const TextArea: React.FC<Props> = (props) => {

    return (
        <TextInp 
          width={props.width}
          height={props.height}
          bgColor={props.bgColor}
          onChange={props.handleChange}
          value={props.value}
          placeholder={props.placeholder}
          style={props.style}
        />
    )
}